<template>
	<el-dialog :visible.sync="is_visible" :width="_gHlp.isEmpty(fileData) ? '40%' : '70%'" @close="hide" title="Bulk Import Customer Data">
		<b-row >
			<b-col cols="12">
				<h4>Import any .CSV, .XLS or .XLSX file type</h4>
				<b-link :href="template_url" download>Download template file</b-link>
			</b-col>
			<b-col cols="12">
				<vue-dropzone id="dropzone" :options="dropzoneOptions" :useCustomSlot=true v-on:vdropzone-file-added="addFile"
					v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-success="importSuccess"
					v-on:vdropzone-error="importError">
					<b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
					<p class="mb-0">Upload files or Drop files here</p>
				</vue-dropzone>
			</b-col>
			<b-col cols="12">
				<small class="text-break">*customer are distinguished by their nric.</small>
			</b-col>
		</b-row>

		<div v-if="!_gHlp.isEmpty(this.checkData.summary)" v-loading="is_loading_file">
			<b-row class="d-flex justify-content-center">
				<b-col cols="12">
					<el-collapse accordion class="border-0">
						<el-collapse-item name="1" class="my-3" style="min-width: 800px !important;">
							<div slot="title" class="collapse-header px-3">
								<h3 class="mb-0">Total {{ checkData.created }} New Record<br />
									<small class="text-success">A list of new customer and not exist on system</small>
								</h3>
							</div>
							<CustomerImportItems :tableData="tableDataNew" :import_status="'NEW'" />
						</el-collapse-item>
						<el-collapse-item name="2" class="my-3" style="min-width: 800px !important;">
							<div slot="title" class="collapse-header px-3">
								<h3 class="mb-0">Total {{ checkData.updated }} Existing Record <br />
									<small class="text-warning">A list of existing customer. It will overide or update existing data</small>
								</h3>
							</div>
							<CustomerImportItems :tableData="tableDataExists" :import_status="'EXISTS'" />
						</el-collapse-item>
					</el-collapse>
				</b-col>
				<b-col cols="12">
					<el-button type="danger" @click="hide">Cancel</el-button>
					<el-button type="primary" @click="proceedImport" :loading="is_loading">Import</el-button>
				</b-col>
			</b-row>
		</div>
		
	</el-dialog>
</template>

<script>
import { Button, Checkbox, Table, TableColumn, Collapse, CollapseItem, Dialog } from 'element-ui'
import vue2Dropzone, { methods } from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {
	services,
	getHeader,
} from '@/assets/js/httpImports.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import CustomerImportItems from '@/views/CustomerProfile/CustomerModals/CustomerImport/CustomerImportItems'

export default {
	name: 'import-files-modal',
	components: {
		CustomerImportItems,
		vueDropzone: vue2Dropzone,
		[Button.name]: Button,
		[Dialog.name]: Dialog,
		[Checkbox.name]: Checkbox,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem
	},
	data() {
		return {
			template_url: 'https://fintos-public.s3.ap-southeast-1.amazonaws.com/import_customer_template_28112024.xlsx',
			is_visible: false,
			is_override: false,
			is_loading: false,
			fileData: null,
			checkData: {
				created: 0,
				updated: 0,
				failed: 0,
				summary: [],
			},
			dropzoneOptions: {
				url: services.customer + 'customer-import',
				thumbnailWidth: 200,
				addRemoveLinks: true,
				paramName: 'import_file',
				headers: { ...getHeader(), "Cache-Control": ""},
			}
		}
	},
	watch: {
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		is_loading_file(){
			return _gHlp.isLoading('checking_file')
		},
		tableDataExists() {
			if (_gHlp.isEmpty(this.checkData) || _gHlp.isEmpty(this.checkData.summary)) return [];
			return this.checkData.summary.filter((data) => {
				return data.import_status == "EXISTS";
			})
		},
		tableDataNew() {
			if (_gHlp.isEmpty(this.checkData) || _gHlp.isEmpty(this.checkData.summary)) return [];
			return this.checkData.summary.filter((data) => {
				return data.import_status == "NEW";
			})
		}
	},
	methods: {
		...mapActions(useCustomerStore, ['importCustomer']),
		show(){
			this.clear();
			this.is_visible = true
		},
		hide(){
			this.is_visible = false;
			this.clear();
		},
		clear(){
			this.is_loading = false
			this.fileData = null;
			this.checkData = {
				created: 0,
				updated: 0,
				failed: 0,
				summary: [],
			};
		},
		addFile(file) {
			this.fileData = file;
		},
		sendingEvent(file, xhr, formData) {
			_gHlp.setLoading('checking_file')
			formData.append("is_override", this.is_override);
			formData.append("is_check", 1);
		},
		importSuccess(file, res) {
			setTimeout(() => {
				this.checkData = res.data;
				_gHlp.removeLoading('checking_file')
			}, 1000);
		},
		importError(file, message, xhr) {
			_gHlp.removeLoading('checking_file')
			file.previewElement.querySelectorAll('.dz-error-message span')[0].textContent = message.message;
			_gNotif.errorFunction(xhr, '<b>Import Error: </b>' + message.message)
		},
		async proceedImport() {
			this.is_loading = true
			let isDirty = (this.tableDataExists.length > 0);
			if (!isDirty || confirm("Your import data has detected have duplicate or existing customers, are you sure override or duplicate for the existing customers ?")) {
				const formData = new FormData();
				formData.append("is_override", (this.checkData.updated > 0 ? true : false));
				formData.append("is_check", 0);
				formData.append("import_file", (this.fileData));

				await this.importCustomer(formData);
				this.$emit('importSuccess');
				this.hide();
			}
			this.is_loading = false
		}
	}
}
</script>